export var reduxKey = '@@CHAT';
export var actionKey = '@@CHAT';
export var pluginName = 'DeviantArt';
export var chatServerUrl = 'https://www.deviantart.com/_napi/shared_api/chat/';
export var maxGroupChatUsers = 20;
//# sourceMappingURL=constants.js.map